import { oc } from '@orpc/contract'
import { z } from 'zod'
import { authUserSchema } from './auth'
import { localeSchema } from '../locale'
import { appSettingsSchema } from './admin'

export const organizationMembershipSummarySchema = z.object({
  organizationId: z.string().min(1),
  role: z.enum(['owner', 'admin', 'member']),
  isGuest: z.boolean(),
})

export const projectMembershipSummarySchema = z.object({
  projectId: z.string().min(1),
  organizationId: z.string().min(1),
  role: z.enum(['owner', 'admin', 'member']),
})

export const meUserSchema = authUserSchema.extend({
  updatedAt: z.string(),
})

export const meOrganizationSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  slug: z.string().min(1),
  prefix: z.string().nullable(),
  role: z.enum(['owner', 'admin', 'member']),
})

export const meProjectSchema = z.object({
  id: z.string().min(1),
  organizationId: z.string().min(1),
  name: z.string().min(1),
  slug: z.string().min(1),
  role: z.enum(['owner', 'admin', 'member']),
})

export const meGetContract = oc.input(z.object({}).optional()).output(
  z.object({
    user: meUserSchema,
    isSuperAdmin: z.boolean(),
    organization: meOrganizationSchema.nullable(),
    project: meProjectSchema.nullable(),
    memberships: z.object({
      organizations: z.array(organizationMembershipSummarySchema),
      projects: z.array(projectMembershipSummarySchema),
    }),
    /** Global super-admin settings the SPA gates on (Jam recorder, …). */
    appSettings: appSettingsSchema,
  })
)

const updateProfileInputSchema = z
  .object({
    name: z.string().trim().min(1).max(120).optional(),
    phone: z.string().trim().min(1).max(40).optional(),
    locale: localeSchema.optional(),
  })
  .refine(
    (value) => value.name !== undefined || value.phone !== undefined || value.locale !== undefined,
    {
      message: 'At least one field must be provided',
    }
  )

export const updateProfileContract = oc.input(updateProfileInputSchema).output(
  z.object({
    user: meUserSchema,
  })
)

/**
 * Remember the project the user just opened, so the app root and the profile
 * page return there. Called from the project layout on navigation — not on
 * every render.
 */
export const setLastProjectContract = oc
  .input(z.object({ projectId: z.string().min(1) }))
  .output(z.object({ projectId: z.string().min(1) }))

/** Forget the cookies/localStorage HUB keeps for this user's agent browser (PLAN-083). */
export const clearBrowserStateContract = oc
  .input(z.object({}).optional())
  .output(z.object({ success: z.literal(true) }))

export const uploadAvatarContract = oc
  .input(
    z.object({
      fileName: z.string().trim().min(1),
      mimeType: z.string().trim().min(1),
      base64Data: z.string().min(1),
    })
  )
  .output(
    z.object({
      avatarUrl: z.string(),
    })
  )
